<template>
  <div class="case">
    <div  v-if="isScrolled9">
      <Header/>
    </div>
    <div style="height: 5em;"></div>
    <div class="user-agreement">
      <div class="box">
        <!-- Breadcrumbs -->
        <div class="Breadcrumbs">
          <div class="box">
            <a href='/' class=''>{{ $t('message.privacyBreadcrumbHome') }}</a> &gt; <a href='/service/' class=''>{{ $t('message.privacyBreadcrumbService') }}</a> &gt; <a href='/privacy/'>{{ $t('message.privacyBreadcrumbPrivacy') }}</a>
          </div>
        </div>
        <div class="tbox">
          <div class="title">{{ $t('message.privacyTitle') }}</div>
          <div class="txt">
            <p v-html="$t('message.privacyContent')"></p>
          </div>
        </div>
      </div>
    </div>
    <Footer/>

  </div>
</template>
<script>
import Header from "@/views/header.vue";
import Banner from "../components/Banner";
import Footer from "@/views/footer.vue";


export default {
  components: {
    Header,
    Banner,
    Footer,

  },
  data() {
    return {
      isScrolled9: true,
      loading: true,
      caseList: []
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    window.addEventListener('scroll', this.handleScroll9);
    window.console.log("case");
    this.$http
        .get("Cases/GetCasesAll")
        .then(response => {
          //console.log(response);
          this.caseList = response.data;
          //window.console.log(this.caseList);
          this.loading = false;
        })
        .catch(function(error) {
          window.console.log(error);
        });
  },
  methods:
      {
        handleScroll9() {

          // 获取当前滚动位置
          const scrollY = window.scrollY || window.pageYOffset;

          // 可以设置一个阈值来确定何时改变isScrolled9的值
          const dis = 100;

          // 判断滚动位置是否大于阈值
          if (scrollY > dis) {
            // 向下滚动，将isScrolled9设为false
            this.isScrolled9 = false;
          } else {
            // 向上滚动，将isScrolled9设为true
            this.isScrolled9 = true;
          }

        },
      }
};
</script>

<style lang="scss" scoped>


.between{

  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.center{
  display: flex;align-items: center; text-align: center;justify-content: center
}
.one-third{
  width: 33.333333%;
  height: 50px;
  //background-color: pink;
}


.one-third-1{
  width: 33.333333%;
  height: 15em;
  //background-color: pink;
}

.one-five{
  display: flex;align-items: center; text-align: center;justify-content: center;flex-direction: column;
  width: 20%;
  height: 50px;

}



.case {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  //background-color: #14679f;

  &-section {
    width: 100%;
    &-content {
      width: 1240px;
      min-height: 1000px;
      margin: 0 auto;
      background-color: #fff;

      &-list {
        width: 100%;
        height: 500px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid pink;

        img {
          width: 612px;
          height: 314px;
        }
        .content-list-abstract {
          width: 290px;
          height: 350px;
          padding: 0 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          .abstract-title {
            line-height: 30px;
            font-size: 22px;
            color: #e13834;
          }
          .abstract-content {
            height: 150px;
            color: #484848;
            font-size: 15px;

            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 7;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
            //border: 1px solid pink;
          }
          .more {
            display: flex;
            justify-content: flex-start;
            .text-decoration {
              text-decoration: none;

              span {
                color: #000;
              }
              img {
                width: 12px;
                height: 12px;
              }
            }
          }
        }
        .abstract-active {
          order: -1;
        }
      }
    }
  }
}
</style>